import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import LoginPage from "./components/LoginPage";
import ManagerAdministration from "./components/mangerComponents/ManagerAdministration";
import ManagerHome from "./components/mangerComponents/ManagerHome";
import ClientPage from "./components/mangerComponents/ClientPage";
import PaymentPage from "./components/mangerComponents/PaymentPage";

import AdminHome from "./components/adminComponents/AdminHome";
import UserManagement from "./components/adminComponents/UserManagement";
import UserDetails from "./components/adminComponents/UserDetails";
import Albums from "./components/adminComponents/Albums";
import Frame from "./components/adminComponents/Frame";
import Price from "./components/adminComponents/Price";
import AboutPage from "./components/adminComponents/AboutPage";
import ContactPage from "./components/adminComponents/ContactPage";
import Feedback from "./components/adminComponents/Feedback";

import UserHome from "./components/userComponents/UserHome";
import UserAlbums from "./components/userComponents/UserAlbums";
import UserFrames from "./components/userComponents/UserFrames";
import PhotoSelection from "./components/userComponents/PhotoSelection";
import UserContact from "./components/userComponents/UserContact";
import UserAbout from "./components/userComponents/UserAbout";
import UserPrice from "./components/userComponents/UserPrice";
import StudioDisplay from "./components/StudioDisplay";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/studios" element={<StudioDisplay />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/manager-dashboard" element={<ManagerAdministration />}>
          <Route index element={<Navigate to="home" replace />} />
          <Route path="home" element={<ManagerHome />} />
          <Route path="clients" element={<ClientPage />} />
          <Route path="payment" element={<PaymentPage />} />
        </Route>

        <Route path="/admin-home" element={<AdminHome />}>
          <Route path="users" element={<UserManagement />} />
          <Route path="user/:id" element={<UserDetails />} />
          <Route path="albums" element={<Albums />} />
          <Route path="frame" element={<Frame />} />
          <Route path="price" element={<Price />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="feedback" element={<Feedback />} />
        </Route>

        <Route path="/user-home" element={<UserHome />} />
        <Route path="/user-albums" element={<UserAlbums />} />
        <Route path="/user-frames" element={<UserFrames />} />
        <Route path="/user-photo-selection" element={<PhotoSelection />} />
        <Route path="/user-prices" element={<UserPrice />} />
        <Route path="/user-contact" element={<UserContact />} />
        <Route path="/user-about" element={<UserAbout />} />
       
      </Routes>
    </BrowserRouter>
  );
}

export default App;
